import { t } from 'i18next';
import styles from './EmployerPortalJobs.module.css';

export const jobStatusUI = (item) => {
    const statusStyles = {
        active: {},
        closed: { background: "rgba(255,0,0,0.2)", color: 'red' },
        paused: { background: "rgba(255,235,59,0.2)", color: '#ff9800' },
        draft: { background: "rgba(128,128,128,0.2)", color: 'gray' },
        pending: { background: "rgba(255,235,59,0.2)", color: '#ff9800' }
    };
    const statusText = item.status === 'active' ? 'filterButtons.open' : 'general.UI.' + item.status;
    return <div className={styles.jobStatus} style={statusStyles[item.status]}>{t(statusText)}</div>
}
